import { render } from "./CustomerList.vue?vue&type=template&id=23e80bbe&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"

import "./CustomerList.vue?vue&type=style&index=0&id=23e80bbe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e80bbe"],['__file',"src/views/qywx/common/partner/customer/CustomerList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23e80bbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23e80bbe', __exports__)) {
    api.reload('23e80bbe', __exports__)
  }
  
  module.hot.accept("./CustomerList.vue?vue&type=template&id=23e80bbe&scoped=true", () => {
    api.rerender('23e80bbe', render)
  })

}


export default __exports__